import { useApiQuery } from '../useApiQuery';
import { creditMemoKeys } from '@/lib/queryKeys';
import { creditMemoEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api/client';
import type { AutoSuggestCreditEntry } from '@/types/creditMemo';

interface UseAutoSuggestArgs {
  contactId: string;
  invoiceId?: string;
  enabled?: boolean;
}

/** Spec §8.2 — auto-suggestion for the invoice editor. */
export function useAutoSuggestCredit({ contactId, invoiceId, enabled = true }: UseAutoSuggestArgs) {
  return useApiQuery<AutoSuggestCreditEntry[]>({
    queryKey: creditMemoKeys.autoSuggest(contactId, invoiceId),
    queryFn: () =>
      apiGet<AutoSuggestCreditEntry[]>(
        operationsClient,
        creditMemoEndpoints.autoSuggest(contactId),
        invoiceId ? { params: { invoiceId } } : undefined,
      ),
    enabled: enabled && Boolean(contactId),
    showErrorToast: false,
  });
}
